import { render } from "./UnitIcon.vue?vue&type=template&id=bac0f124&scoped=true"
import script from "./UnitIcon.vue?vue&type=script&lang=js"
export * from "./UnitIcon.vue?vue&type=script&lang=js"

import "./UnitIcon.vue?vue&type=style&index=0&id=bac0f124&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bac0f124"]])

export default __exports__